// export const baseUrl = "http://127.0.0.1:8000"
 export const baseUrl = "https://fraternity.technaureus.com"
// export const baseUrl = "http://64.227.129.37:8080"
// export const baseUrl = "https://admin.khadamatiplus.com/"
